import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'do_pay_slips_contain_accurate_info_on_worker_wages_in_a_detaile'

export const dataPointDefinition = {
  retracedId: 'do_pay_slips_contain_accurate_info_on_worker_wages_in_a_detaile',
  name: 'Do pay slips contain accurate information on worker wages in a detailed and comprehensive manner for workers?',
  description:
    'The intent of this question is to understand specifically whether workers can read their pay slip and understand its contents. For example, do workers know where to find their base rate of pay? Or what certain legal withholdings mean?\r\r\n\r\r\nFor example, if workers receive a pay slip, but struggle to understand how their final net wage (their "take home pay") is calculated, this response selection should NOT be selected.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-16--3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8720,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
